module.exports = __webpack_public_path__ + "img/n3.4aed511c.png";